import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton, Stack } from '@mui/material'
import type { FC, PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, type To } from 'react-router'

import { COLORS, ICONS, unit } from '@hcr/ui'

import { LayoutBase, Metadata } from '../../../../common'

interface LayoutAccountEditProps extends PropsWithChildren {
  backNavigationPath: To
  form?: ReactNode
  headline?: ReactNode
  onClickBackNavigation?: () => void
}

export const LayoutAccountEdit: FC<LayoutAccountEditProps> = ({
  backNavigationPath,
  children,
  form,
  headline,
  onClickBackNavigation,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <LayoutBase>
      <Metadata title={t('page-title.account-edit')} />
      <IconButton
        onClick={() => {
          if (onClickBackNavigation) {
            onClickBackNavigation()

            return
          }

          void navigate(backNavigationPath)
        }}
        aria-label={t('context-menu.close')}
        sx={{
          position: 'absolute',
          top: unit(4),
          left: unit(6),
          zIndex: 1,
          alignSelf: 'end',
          margin: `${unit(4.5)} ${unit(8)} 0 0`,
          padding: 0,
          fontSize: unit(6),
        }}
      >
        <FontAwesomeIcon icon={ICONS.farArrowLeft} />
      </IconButton>
      <Stack
        component='main'
        sx={{
          position: 'relative',
          backgroundColor: COLORS.white,
          padding: `${unit(24)} ${unit(7)} ${unit(5)}`,
          minHeight: '100vh',
          gap: unit(6),
        }}
      >
        {headline}
        {form}
        {children}
      </Stack>
    </LayoutBase>
  )
}
